import React, { lazy, useEffect } from "react";
import { useSelector } from "react-redux";
import { addScrollToRootElement } from "../../assets/common/rootElementConfig";
import { ReactComponent as IconToTop } from "../../assets/images/icon-to-top.svg";
import "../../assets/common/animations";
import "../../style/app.scss";
import "react-loading-skeleton/dist/skeleton.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const Header = lazy(() => import("../layouts/header"));
const Footer = lazy(() => import("../layouts/footer"));
const AppRouter = lazy(() => import("./appRouter"));
const Loading = lazy(() => import("../content/loading"));

const DefaultThemeView = () => {
  const theme = useSelector((state) => state.study.Theme);
  const loading = useSelector((state) => state.loading);
  useEffect(() => {
    addScrollToRootElement();
  }, []);
  return (
    <React.Fragment>
      <Header />
      <AppRouter />
      <Loading visible={loading} />
      <a
        href="#top"
        to="/"
        className={`scroll-down btn-fab-sticky btn-fab-sticky-${theme} d-block d-none d-sm-block`}
        aria-label="back to top"
        id="top-link"
      >
        <IconToTop />
      </a>
      <Footer />
    </React.Fragment>
  );
};
export default DefaultThemeView;
